import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
import { Response } from '@angular/http/src/static_response';
import {Observable} from 'rxjs/Observable';
import {Headers} from '@angular/http';
import { environment } from '../environments/environment';

@Injectable()
export class PostService {

  post_type_list: Array<string>;

  post_type: string;

  get_post_url: string;

  update_post_url: string;

  page_number: number;

  max_pages: number;

  baseurl: string;

  nones: string;


  constructor(private http: Http) { 
    this.baseurl = (<any>window).config.baseurl;
    this.nones = (<any>window).config.nones;
    this.post_type_list = (<any>window).config.post_type;
    this.get_post_url = this.baseurl+'/wp-json/dvin508-seo/v1/post_type';
    this.update_post_url = this.baseurl+'/wp-json/dvin508-seo/v1/update_post';
    this.page_number = 1;
  }

  /* get post list of any type of media */
  get_post_list(){

    return this.http.get(this.get_post_url+'/'+this.post_type+'/'+this.page_number,
    { headers: new Headers({ 'X-WP-Nonce': this.nones }) }
  );
  
  }

  /* change type of post and reset page number to 1 so new type is initialized from 1*/
  reset_post_type(post_type){

    this.page_number = 1; // setting page number to 1 will make sure we are loading new type with page 1
    
    this.post_type = post_type;

  }

  update_post(media){
    return this.http.post(
      this.update_post_url,
      JSON.stringify(media),
      { headers: new Headers({ 'Content-Type': 'application/json', 'X-WP-Nonce': this.nones }) }
    )
  }

  next_page(){
    if((this.page_number+1) <= this.max_pages){
      this.page_number = this.page_number + 1;
      return true;
    }
    return false;
  }

  previous_page(){
    if((this.page_number) > 1){
      this.page_number = this.page_number - 1;
      return true;
    }
    return false;
  }


}



// WEBPACK FOOTER //
// E:/UniServerZ/www/seo/wp-content/plugins/dvin508-ada-seo/seo/src/app/post.service.ts